import { render } from "./LoadingSpinnerNr1.vue?vue&type=template&id=151de50c&scoped=true"
import script from "./LoadingSpinnerNr1.vue?vue&type=script&lang=js"
export * from "./LoadingSpinnerNr1.vue?vue&type=script&lang=js"

import "./LoadingSpinnerNr1.vue?vue&type=style&index=0&id=151de50c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151de50c"]])

export default __exports__